export const deviceContent = {
    fr: {
        eyebrow: 'ÉCOSYSTÈME CONNECTÉ',
        title: 'Marche avec tous vos appareils.',
    },
    es: {
        eyebrow: 'ECOSISTEMA CONECTADO',
        title: 'Funciona con todos tus dispositivos.',
    },
};
